import { DatePipe } from "@angular/common";
import { Injectable, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { appService } from "../../../_services/app.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
// Added by priya - 16/01/2026 - Common service for Ulip Api's - cn(PRIYA-JAN26-013)
@Injectable()
export class UlipService {

  constructor(
    private _appService: appService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private modalService: NgbModal
  ) { }

  // Added by priya - 19/01/2026 - Getting Driver Ulip (Sarathi) data - cn(PRIYA-JAN26-013)
  ValidateDriverUlip(LicenseNo, Dob): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!LicenseNo) {
        this.toastr.warning("License No is missing");
        reject('License No missing');
        return;
      }

      if (!Dob) {
        this.toastr.warning("Date of Birth is missing");
        reject('Dob missing');
        return;
      }

      // Added by priya - 28/03/2026 - cn(PRIYA-MAR26-013)
      LicenseNo = LicenseNo.trim().toUpperCase();
      // ✅ Validate format: GJ04 20120005008
      const dlRegex = /^[A-Z]{2}\d{2}\s\d{4}\d{7}$/;
      if (!dlRegex.test(LicenseNo)) {
        this.toastr.warning("Invalid License Number format (e.g. XX00 01234567890)");
        reject('Invalid DL format');
        return;
      }
      if (Dob) {
        const [day, monthStr, year] = Dob.split('-');
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = (months.indexOf(monthStr) + 1).toString().padStart(2, '0');
        const formatted = `${year}-${month}-${day.padStart(2, '0')}`;
        console.log(formatted); // 1987-05-26
        Dob = formatted;
      }
      this._appService.GetByTwoId("VehicleMaster", "GetNewSarathiData", LicenseNo, Dob).subscribe(
      (response) => {
        if (!response.sarathiData) {
          this.toastr.warning("No driver data found for the provided license number and date of birth.");
        }
        resolve(response);
        return response;
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
        reject(err);
      });
    });
  }

  // Added by priya - 19/01/2026 - Getting Vehicle Ulip (Vahan) data - cn(PRIYA-JAN26-013)
  ValidateVehicleUlip(VehicleNo): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!VehicleNo) {
        this.toastr.warning("Vehicle No is missing");
        reject('Vehicle No missing');
        return;
      }
      this._appService.GetByOneParam("VehicleMaster", "GetNewVahanData", VehicleNo).subscribe(
        (response) => {
          if (!response.vahanData) {
            this.toastr.warning("No vehicle data found for the provided vehicle No.");
          }
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        });
    });
  }

  // Added by priya - 19/01/2026 - Saving driver ulip - cn(PRIYA-JAN26-013)
  SaveDriverUlip(LicenseNo, Dob, data, UserId): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!LicenseNo) {
        this.toastr.warning("License No is missing");
        reject('License No missing');
        return;
      }
      if (!Dob) {
        this.toastr.warning("Date of Birth is missing");
        reject('Dob missing');
        return;
      }
      var currentDATE1 = new Date();
      var formattedDate1 = currentDATE1.toISOString().split('T')[0] + 'T00:00:00';
      if (data.DlValidity <= formattedDate1) {
        this.toastr.warning("Driver license is expired.");
        reject('License expired');
        return;
      }
      const PostData = {
        Type: 'Driver',
        ReferenceNo: LicenseNo,
        ReferenceDate: Dob,
        Response: JSON.stringify(data),
        CreatedBy: UserId,
      }
      this._appService.Post("VehicleMaster", "saveUlipData", PostData).subscribe(
      (response) => {
        this.toastr.clear();
        this.toastr.success("ULIP data saved successfully");
        resolve(response);
        return response;
      },
      (err) => {
        this.toastr.error("Error while saving ULIP data");
        reject(err);
      });
    });
  }

  // Added by priya - 19/01/2026 - Saving Vehicle ulip - cn(PRIYA-JAN26-013)
  SaveVehicleUlip(Vehicle, data, UserId): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!Vehicle) {
        this.toastr.warning("Vehicle No is missing");
        reject('Vehicle No missing');
        return;
      }
      const currentDate = new Date();
      const insuranceDate = this.parseDate(data.RcInsuranceUpto);
      const fitDate = this.parseDate(data.RcFitUpto);
      const taxDate = this.parseDate(data.RcTaxUpto);
      if (
        !isNaN(insuranceDate.getTime()) &&
        !isNaN(fitDate.getTime()) &&
        !isNaN(taxDate.getTime()) &&
        insuranceDate > currentDate &&
        fitDate > currentDate &&
        taxDate > currentDate
      ) {
        const PostData = {
          Type: 'Vehicle',
          ReferenceNo: Vehicle,
          ReferenceDate: null,
          Response: JSON.stringify(data),
          CreatedBy: UserId,
        }
        this._appService.Post("VehicleMaster", "saveUlipData", PostData).subscribe(
        (response) => {
          this.toastr.success("ULIP data saved successfully");
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error while saving ULIP data");
          reject(err);
        });
      } else {
        this.toastr.warning("The vehicle's insurance, fitness, or tax is not valid.");
        reject('Vehicle dates invalid');
      }
    });
  }

  // Added by priya - 20/01/2026 - validate and save both vehicle and driver ulip - cn(PRIYA-JAN26-013)
  ValidateVehicleDriverUlip(LicenseNo, Dob, VehicleNo, UserId): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!VehicleNo) {
        this.toastr.warning("Vehicle No is missing");
        reject('Vehicle No missing');
        return;
      }
      if (!LicenseNo) {
        this.toastr.warning("License No is missing");
        reject('License No missing');
        return;
      }
      if (!Dob) {
        this.toastr.warning("Date of Birth is missing");
        reject('Dob missing');
        return;
      }
      // Added by priya - 28/03/2026 - cn(PRIYA-MAR26-013)
      LicenseNo = LicenseNo.trim().toUpperCase();
      // ✅ Validate format: GJ04 20120005008
      const dlRegex = /^[A-Z]{2}\d{2}\s\d{4}\d{7}$/;
      if (!dlRegex.test(LicenseNo)) {
        this.toastr.warning("Invalid License Number format (e.g. XX00 01234567890)");
        reject('Invalid DL format');
        return;
      }
      if (Dob) {
        const [day, monthStr, year] = Dob.split('-');
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = (months.indexOf(monthStr) + 1).toString().padStart(2, '0');
        Dob = `${year}-${month}-${day.padStart(2, '0')}`;
      }
      this._appService.GetByOneParam("VehicleMaster", "GetNewVahanData", VehicleNo).subscribe(
        (response) => {
          if (!(response.vahanData && Object.keys(response.vahanData).length > 0)) {
            this.toastr.warning("No vehicle data found for the provided vehicle No.");
            reject('Vehicle data not found');
            return;
          }
          const currentDate = new Date();
          const insuranceDate = this.parseDate(response.vahanData.RcInsuranceUpto);
          const fitDate = this.parseDate(response.vahanData.RcFitUpto);
          const taxDate = this.parseDate(response.vahanData.RcTaxUpto);
          if (
            isNaN(insuranceDate.getTime()) ||
            isNaN(fitDate.getTime()) ||
            isNaN(taxDate.getTime()) ||
            insuranceDate <= currentDate ||
            fitDate <= currentDate ||
            taxDate <= currentDate
          ) {
            this.toastr.warning("The vehicle's insurance, fitness, or tax is not valid.");
            reject('Vehicle dates invalid');
            return;
          }
          const vehiclePostData = {
            Type: 'Vehicle',
            ReferenceNo: VehicleNo,
            ReferenceDate: null,
            Response: JSON.stringify(response.vahanData),
            CreatedBy: UserId,
          };
          this._appService.Post("VehicleMaster", "saveUlipData", vehiclePostData).subscribe(
            () => {
              this._appService.GetByTwoId("VehicleMaster", "GetNewSarathiData", LicenseNo, Dob).subscribe(
                (response) => {
                  if (!(response.sarathiData && Object.keys(response.sarathiData).length > 0)) {
                    this.toastr.warning("No driver data found for the provided license number and date of birth.");
                    reject('Driver data not found');
                    return;
                  }
                  const today = new Date().toISOString().split('T')[0] + 'T00:00:00';
                  if (response.sarathiData.DlValidity <= today) {
                    this.toastr.warning("Driver license is expired.");
                    reject('License expired');
                    return;
                  }
                  const driverPostData = {
                    Type: 'Driver',
                    ReferenceNo: LicenseNo,
                    ReferenceDate: Dob,
                    Response: JSON.stringify(response.sarathiData),
                    CreatedBy: UserId,
                  };
                  this._appService.Post("VehicleMaster", "saveUlipData", driverPostData).subscribe(
                    (finalResponse) => {
                      this.toastr.success("ULIP data saved successfully");
                      resolve(finalResponse);   // ✅ resolve ONLY here
                    },
                    (err) => {
                      this.toastr.error("Error while saving ULIP data");
                      reject(err);
                    }
                  );
                },
                (err) => {
                  this.toastr.error("Error occurred while fetching data !", "error");
                  reject(err);
                }
              );
            },
            (err) => {
              this.toastr.error("Error while saving ULIP data");
              reject(err);
            }
          );
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  // Added by priya - 20/01/2026 - Get Driver ulip data - cn(PRIYA-JAN26-013)
  GetDriverUlipData(LicenseNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByOneParam("VehicleMaster", "GetDriverULIPData", LicenseNo).subscribe(
        (response) => {
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        });
    });
  }

  // Added by priya - 20/01/2026 - Get Vehicle ulip data - cn(PRIYA-JAN26-013)
  GetVehicleUlipData(VehicleNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByOneParam("VehicleMaster", "GetVehicleUlipData", VehicleNo).subscribe(
        (response) => {
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        });
    });
  }

  // Added by priya - 20/01/2026 - Added helper for parse date - cn(PRIYA-JAN26-013)
  private parseDate(dateStr: string): Date {
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split('-');
      return new Date(`${year}-${month}-${day}`);
    }
    return new Date(dateStr);
  }

  // Added by priya - 22/01/2026 - Validating ewaybill - cn(PRIYA-JAN26-013)
  ValidateEwayBillUlip(EwayNo): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!EwayNo) {
        this.toastr.warning("EwayBill No is missing");
        reject('Eway Bill No missing');
        return;
      }
      this._appService.GetByOneParam("VehicleMaster", "VerifyEwaybillULIP", EwayNo).subscribe(
        (response) => {
          if (!response.ewayData && response.message === '404') {
            this.toastr.warning("No eway data found for the provided ewaybill No.");
          }
          else if (!response.ewayData && (response.message && response.message !== 'null')) {
            // Handles cases like "no data found" or other string messages
            this.toastr.warning(response.message);
          }
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        });
    });
  }

  // Added by priya - 23/01/2026 - Get Vehicle ulip data - cn(PRIYA-JAN26-013)
  GetEwayUlipData(EwayNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByOneParam("VehicleMaster", "GetEwayUlipData", EwayNo).subscribe(
        (response) => {
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        });
    });
  }

  // Added by priya - 25/03/2026 - Get Ulip Gst data - cn(PRIYA-MAR26-010)
  ValidateGstInUlip(GSTNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByOneParam("Company", "GetGSTINData", GSTNo).subscribe(
        (response) => {
          if (!response.gstinData && (response.message && response.message !== 'null')) {
            // Handles cases like "no data found" or other string messages
            this.toastr.warning(response.message);
          } else if (!response.gstinData) {
            this.toastr.warning("No GST data found for the provided GST No.");
          } 
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        });
    });
  }

  // Added by priya - 25/03/2026 - Saving gst ulip - cn(PRIYA-MAR26-010)
  SaveGstUlip(GstNo, data, UserId): Promise<any> {
    return new Promise((resolve, reject) => {
      const PostData = {
        Type: 'Network',
        ReferenceNo: GstNo,
        ReferenceDate: null,
        Response: JSON.stringify(data),
        CreatedBy: UserId,
      }
      this._appService.Post("VehicleMaster", "saveUlipData", PostData).subscribe(
        (response) => {
          this.toastr.clear();
          // this.toastr.success("ULIP data saved successfully");
          resolve(response);
          return response;
        },
        (err) => {
          // this.toastr.error("Error while saving ULIP data");
          reject(err);
        });
    });
  }

}
